import {
  UITranslationTranslatable,
  UITranslation,
  NewUITranslation,
  UITranslationDictionary,
} from '../../shared/types/uitranslation';

export const UITRANSLATION_DEFAULT_NAMESPACE = 'default';

export function translate(
  key: UITranslationTranslatable,
  translations: UITranslation[],
  language: string,
  namespace = UITRANSLATION_DEFAULT_NAMESPACE
): string | undefined {
  const transl = translations.find(t => t.namespace === namespace);
  if (!transl) return undefined;

  const dictionary = transl.dictionary;
  if (!dictionary) return undefined;

  const word = dictionary[key];
  if (!word) return undefined;

  const text = word.text[language];
  if (!text || !text.active) return undefined;

  return text.value;
}

export function generateDefaultNewUITranslation(property: string): NewUITranslation {
  return {
    namespace: UITRANSLATION_DEFAULT_NAMESPACE,
    property,
  };
}

export function makeDefaultUITranslationDictionary(languages: string[]): UITranslationDictionary {
  function makeEmptyText() {
    return languages.reduce((acc, x) => {
      const newAcc = {
        ...acc,
        [x]: {
          active: false,
          value: '',
        },
      };

      return newAcc;
    }, {});
  }

  return {
    DDP_EVENTS_LABEL: {
      text: makeEmptyText(),
    },
    DDP_ACTIVITIES_LABEL: {
      text: makeEmptyText(),
    },
    DDP_HOURS_LABEL: {
      text: makeEmptyText(),
    },
    DDP_TODAY_LABEL: {
      text: makeEmptyText(),
    },
    DDP_NO_CONTENT_LABEL: {
      text: makeEmptyText(),
    },
    VENUE_RUNDOWN_CLOSED: {
      text: makeEmptyText(),
    },
    MOBILE_NO_FAVORITES_TEXT: {
      text: makeEmptyText(),
    },
    MOBILE_NO_RESULTS_TEXT: {
      text: makeEmptyText(),
    },
    MOBILE_LINEUP_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_EXPLORE_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_INFORMATION_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_MESSAGES_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_OFFERS_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_FAVORITES_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_TODAY_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_TOMORROW_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_TRENDING_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_UPCOMING_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_OPEN_NOW_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_VENUE_OPEN_LABEL: {
      text: makeEmptyText(),
    },
    MOBILE_VENUE_CLOSED_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_TRENDING_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_CLOSED_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_OPEN_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_EXPLORE_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_LINEUP_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_OFFERS_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_TODAY_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_TOMORROW_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_QR_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_OTHER_TIMES_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_AVAILABLE_AT_LABEL: {
      text: makeEmptyText(),
    },
    BOARD_EVENTS_LABEL: {
      text: makeEmptyText(),
    },
  };
}
